#import "../../../../../core-entity/graphql/fragments/file-fragment.graphql"
fragment LeadAttachmentsFragment on Lead {
    id
    files {
        ...FileFragment
    }
}
